import Grid from '@material-ui/core/Grid';
import { ThemeProvider } from '@material-ui/core/styles';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BusinessIcon from '@material-ui/icons/Business';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import { Refresh } from '@material-ui/icons';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Snackbar from '@material-ui/core/Snackbar';
import React, { useEffect } from 'react';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import { allProviders, updateProvider } from 'redux/actions/providers.actions';
import { useThunkDispatch, useTypedSelector } from 'hooks';

import { myTheme, Styles, getModalStyle, StyledTableCell, StyledTableRow } from '../Tools';
import { NewProvider } from './NewProvider';
import Modal from '@material-ui/core/Modal';
import ModalCustom from 'components/Tools/ModalCustom';

import { Provider } from '../../types/api/responses';
import { shouldReload } from '../../utils/state.handlers';
import Pagination from '@material-ui/lab/Pagination';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Alert } from '../Tools';
import { Loading } from '../Tools/Loading';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import AddBoxIcon from '@material-ui/icons/AddBox';

const SIZE = 10,
  INITPAGE = 1;

function SearchDetails() {
  const classes = Styles();

  const providers = useTypedSelector((z) => z.providers);
  const dispatch = useThunkDispatch();

  const [nameSearch, setNameSearch] = React.useState(
    providers.filter.NameContains ? providers.filter.NameContains : '',
  );

  const [openStatus, setOpenStatus] = React.useState(false);
  const [theStatus, setTheStatus] = React.useState(
    providers.filter.Status != null ? providers.filter.Status : '0',
  );

  const handleResetSearch = () => {
    setNameSearch('');
    setTheStatus('0');
    dispatch(
      allProviders(
        { page: INITPAGE, size: SIZE },
        {
          NameContains: null,
          Status: null,
        },
      ),
    );
  };

  //evento de cambio en nombre a buscar
  const handleChangeNameSearch = (event: React.ChangeEvent<{ value: unknown }>) => {
    setNameSearch(event.target.value as string);
  };

  //evento de busqueda segun nombre
  const handleSearch = () => {
    //alert(nameSearch + 'F');
    dispatch(
      allProviders(
        { page: INITPAGE, size: SIZE },
        {
          NameContains: nameSearch,
          Status: providers.filter.Status,
        },
      ),
    );
  };

  const handleOpenStatus = () => {
    setOpenStatus(true);
  };

  const handleClosedStatus = () => {
    setOpenStatus(false);
  };

  const handleChangeStatus = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value = event.target.value as string;
    setTheStatus(value);
    dispatch(
      allProviders(
        { page: INITPAGE, size: SIZE },
        {
          NameContains: providers.filter.NameContains,
          Status: value === '0' ? null : value,
        },
      ),
    );
  };

  return (
    <form className={classes.rootForm} noValidate autoComplete="off">
      <div style={{ display: 'inline-flex', alignItems: 'center', marginRight: '10px' }}>
        <TextField
          id="outlined-read-only-input"
          label="Nombre Proveedor"
          inputProps={{ maxLength: 50 }}
          value={nameSearch}
          onChange={handleChangeNameSearch}
          onKeyPress={(ev) => {
            if (ev.key === 'Enter') {
              ev.preventDefault();
              handleSearch();
            }
          }}
          variant="outlined"
          required
        />
        <FormControl style={{ marginRight: '10px' }}>
          <InputLabel id="select-filter-rol">Estado</InputLabel>
          <Select
            labelId="select-filter-rol"
            id="filter-controlled-open-select-rol"
            open={openStatus}
            onClose={handleClosedStatus}
            onOpen={handleOpenStatus}
            value={theStatus}
            onChange={handleChangeStatus}
          >
            <MenuItem value={'0'}>Todos</MenuItem>
            <MenuItem value={'Disabled'}>Inactivos</MenuItem>
            <MenuItem value={'Active'}>Activos</MenuItem>
          </Select>
        </FormControl>
        {providers.isLoading ? (
          <div>
            <CircularProgress />
          </div>
        ) : (
          <div />
        )}
        <Button
          variant="outlined"
          onClick={handleResetSearch}
          className={classes.submit}
          style={{ color: '#343c89', marginLeft: '15px' }}
          startIcon={<Refresh />}
        >
          Refrescar
        </Button>
      </div>
    </form>
  );
}

function ListProvider() {
  const classes = Styles();
  const providers = useTypedSelector((u) => u.providers);

  //modal
  const [modalStyle] = React.useState(getModalStyle(40, 20));
  const [modalActive, setmodalActive] = React.useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const [page, setPage] = React.useState(1);
  const [minLoadingComplete, setMinLoadingComplete] = React.useState(false);

  // Add loading effect for minimum display time
  React.useEffect(() => {
    let timer: NodeJS.Timeout;
    
    if (providers.isLoading) {
      setMinLoadingComplete(false);
      timer = setTimeout(() => {
        setMinLoadingComplete(true);
      }, 3000); 
    } else if (!providers.isLoading) {
      const checkAndComplete = () => {
        if (!providers.isLoading) {
          setMinLoadingComplete(true);
        }
      };
      
      checkAndComplete();
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [providers.isLoading]);
  const [thePorvider, setTheProvider] = React.useState({ id: 0, name: '', active: false });
  const dispatch = useThunkDispatch();
  const [isNew, setIsNew] = React.useState(true);
  const [messageSnack, setMessageSnack] = React.useState<string | null>(null);

  useEffect(() => {
    if (shouldReload(providers)) {
      dispatch(allProviders({ size: SIZE, page: page }, { NameContains: null, Status: null }));
    }
  }, [providers]);

  const handleOpenModal = () => {
    setOpenModal(true);
    setmodalActive(false);
  };

  const handleChangePage = (event: React.ChangeEvent<unknown>, newPage: number) => {
    dispatch(allProviders({ size: SIZE, page: newPage }, providers.filter));
    setPage(newPage);
  };

  const updateList = () => {
    dispatch(allProviders({ size: SIZE, page: page }, providers.filter));
  };

  const handleCloseModal = (flag: boolean) => {
    setOpenModal(false);
    if (flag) {
      setmodalActive(true);
    }
  };

  const handleChangeModal = ({ provider, flag }: { provider: Provider; flag: boolean }) => {
    setMessageSnack(null);
    setTheProvider(provider);
    setIsNew(flag);
    handleOpenModal();
  };

  const handleDesactive = ({ active, item }: { active: boolean; item: Provider }) => {
    setMessageSnack(
      active ? 'El proveedor se desbloqueó con éxito.' : 'El proveedor se bloqueó con éxito.',
    );
    setmodalActive(false);
    setmodalActive(true);
    dispatch(
      updateProvider({
        id: item.id,
        name: item.name,
        active: active,
      }),
    );
  };

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setmodalActive(false);
  };

  return (
    <ThemeProvider theme={myTheme}>
      <ModalCustom
        className={classes.paperModalNewProvider}
        open={openModal}
        onClose={() => {
          handleCloseModal(false);
        }}
      >
        <NewProvider
          provider={thePorvider}
          isNew={isNew}
          handleClose={handleCloseModal}
          updateList={updateList}
        />
      </ModalCustom>
      <Snackbar open={modalActive} autoHideDuration={15000} onClose={handleClose}>
        {providers.isLoading ? (
          <Alert onClose={handleClose} severity="info">
            <div>{isNew ? 'Agregando' : 'Editando'} Proveedor...</div>
          </Alert>
        ) : (
          <div>
            {providers.error ? (
              <Alert onClose={handleClose} severity="error">
                {providers.error?.name === '1009' ? (
                  <div>Nombre ya registrado</div>
                ) : (
                  <div>ocurrio un error {providers.error.message}</div>
                )}
              </Alert>
            ) : (
              <Alert onClose={handleClose} severity="success">
                {messageSnack ? (
                  <div>{messageSnack}</div>
                ) : (
                  <div>Se {isNew ? 'agregó ' : 'editó'} con éxito el Proveedor</div>
                )}
              </Alert>
            )}
          </div>
        )}
      </Snackbar>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '16px',
        marginBottom: '24px',
        marginTop: '16px'
      }}>
        <BusinessIcon style={{ fontSize: '40px', color: '#343c89' }} />
        <div style={{ fontSize: '2rem', color: '#343c89', fontWeight: 700 }}>
          Proveedores
        </div>
      </div>
      <div className={classes.divider}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Grid item xs={11} style={{ width: '100%' }}>
            <Paper 
              className={`${classes.paper} ${classes.flexWrap}`}
              elevation={3}
              style={{
                borderRadius: '12px',
                padding: '16px 24px',
                marginBottom: '16px'
              }}
            >
              <div className={classes.flexWrap}>
                <SearchDetails />
                <BottomNavigation
                  showLabels
                  onClick={() => {
                    handleChangeModal({
                      provider: {
                        id: 0,
                        name: '',
                        active: true,
                      },
                      flag: true,
                    });
                  }}
                  style={{
                    backgroundColor: 'transparent',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <BottomNavigationAction
                    label="Agregar Registro"
                    icon={<AddBoxIcon />}
                    style={{ 
                      color: '#0e814b',
                      transition: 'all 0.3s ease'
                    }}
                  />
                </BottomNavigation>
              </div>
            </Paper>
          </Grid>
          <Grid item xs={11} style={{ width: '100%', marginTop: '0.1em' }}>
            <Paper elevation={3} style={{ borderRadius: '12px', overflow: 'hidden' }}>
              <TableContainer
                style={{
                  maxHeight: '75vh',
                }}
              >
                <Table className={classes.table} stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Nombre Proveedor</StyledTableCell>
                    <StyledTableCell align="center">Estado</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {providers.providers.providers.map((item) => {
                    return (
                      <StyledTableRow key={item.id}>
                        <StyledTableCell component="th" scope="row">
                          {item.name}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <div className={classes.flexRowCenter}>
                            <BottomNavigation
                              showLabels
                              onClick={() => {
                                handleChangeModal({ provider: item, flag: false });
                              }}
                              className={classes.buttons}
                              style={{ backgroundColor: 'transparent' }}
                            >
                              <BottomNavigationAction
                                label="Editar"
                                icon={<EditIcon />}
                                style={{ 
                                  color: '#343c89', 
                                  margin: '0px',
                                  cursor: 'pointer',
                                  borderRadius: '8px',
                                  transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = 'rgba(52, 60, 137, 0.1)';
                                  e.currentTarget.style.transform = 'scale(1.05)';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = 'transparent';
                                  e.currentTarget.style.transform = 'scale(1)';
                                }}
                              />
                            </BottomNavigation>
                            {providers.isLoading ? (
                              <div>
                                <CircularProgress />
                              </div>
                            ) : (
                              <div>
                                {item.active ? (
                                  <BottomNavigation showLabels className={classes.buttons} style={{ backgroundColor: 'transparent' }}>
                                    <BottomNavigationAction
                                      label="bloquear"
                                      onClick={() => {
                                        handleDesactive({ active: false, item: item });
                                      }}
                                      icon={<LockIcon />}
                                      style={{ 
                                        color: '#dc3545',
                                        cursor: 'pointer',
                                        borderRadius: '8px',
                                        transition: 'all 0.3s ease'
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = 'rgba(220, 53, 69, 0.1)';
                                        e.currentTarget.style.transform = 'scale(1.05)';
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                        e.currentTarget.style.transform = 'scale(1)';
                                      }}
                                    />
                                  </BottomNavigation>
                                ) : (
                                  <BottomNavigation showLabels className={classes.buttons} style={{ backgroundColor: 'transparent' }}>
                                    <BottomNavigationAction
                                      label="desbloquear"
                                      onClick={() => {
                                        handleDesactive({ active: true, item: item });
                                      }}
                                      icon={<LockOpenIcon />}
                                      style={{ 
                                        color: '#0e814b',
                                        cursor: 'pointer',
                                        borderRadius: '8px',
                                        transition: 'all 0.3s ease'
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = 'rgba(14, 129, 75, 0.1)';
                                        e.currentTarget.style.transform = 'scale(1.05)';
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                        e.currentTarget.style.transform = 'scale(1)';
                                      }}
                                    />
                                  </BottomNavigation>
                                )}
                              </div>
                            )}
                          </div>
                        </StyledTableCell>
                      </StyledTableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            </Paper>
          </Grid>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center',
            marginTop: '16px'
          }}>
            {(!minLoadingComplete || providers.isLoading) ? (
              <Loading 
                message="Cargando proveedores..." 
                subMessage="Por favor espere mientras se cargan los proveedores" 
              />
            ) : (
              <div style={{
                backgroundColor: 'white',
                padding: '12px',
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}>
                <Pagination
                  count={providers.providers.meta?.pages}
                  variant="outlined"
                  shape="rounded"
                  page={page}
                  onChange={handleChangePage}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}

export { ListProvider };
